<template>
  <div class="container mt-1">
    <div class="container mt-3">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Email</th>
              <th scope="col">Permessi</th>
              <th scope="col">Edit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users">
              <th scope="row">{{ user.name }}</th>
              <td>{{ user.email }}</td>
              <td v-if="!user.isEditable">{{ permissions[user.accessLevel] }}</td>
              <td v-else>
                <div class="input-group">
                  <select class="custom-select" v-model="selected">
                    <option disabled value="">{{ permissions[user.accessLevel] }}</option>
                    <option value="0">Admin</option>
                    <option value="1">Affiliato</option>
                    <option value="2">Inventor</option>
                    <option value="3">Guest</option>
                  </select>
                </div>
              </td>
              <td v-if="!user.isEditable"><input type="button" class="btn" value="Edit" @click="user.isEditable = !user.isEditable"></td>
              <td v-else><input class="btn" value="save" type="button" @click="() => { user.isEditable = !user.isEditable; updateAcces(selected,user.email) }"/></td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
import { database } from '@/firebase'
import { convertDate, permissionNames } from '@/helpers'
import router from '@/router'

export default {
  name: 'AdminUserDashboard',
  data() {
    return {
      users: [],
      selected: 2,
      permissions: permissionNames
    }
  },
  methods: {
    updateAcces: (selected,email) => {
      database.collection('Users').doc(email).update({accessLevel: selected})
      router.push('/admin/user')
    }
  },
  created() {
    database.collection("Users")
      .onSnapshot(snap => {
        this.users = []
        snap.forEach(userDoc => {
        let user = userDoc.data();
        user.isEditable = false;
        this.users.push(user);
      });
    })

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminUserDashboard.vue